<template>
  <div class="flex items-center justify-center">
    <div v-show="loading" class="absolute flex items-center">
      <base-spinner :size="24" />
    </div>
    <button
      type="button"
      :class="[
        { invisible: loading },
        modelValue ? 'bg-primary-500' : 'bg-gray-200',
        'relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500',
      ]"
      :disabled="disabled"
      role="switch"
      @click="$emit('update:modelValue', !modelValue)"
    >
      <span
        :class="[
          modelValue ? 'translate-x-5' : 'translate-x-0',
          'pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200',
        ]"
      />
    </button>
  </div>
</template>

<script>
export default {
  emits: ["update:modelValue"],
  props: {
    modelValue: Boolean,
    loading: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
